import classnames from "classnames";
import React, { type FC } from "react";
import { type WithTranslation, withTranslation } from "react-i18next";
import { DocumentListingInboundCentralPath } from "src/components/App";
import logo from "../../../images/aic_logo_2026.svg";
import styles from "../../../styles.module.scss";

const PortalLogo: FC<WithTranslation> = ({ t }) => {
  return (
    <div>
      <a
        href={DocumentListingInboundCentralPath}
        title={t("aic_app_page_title_text")}
      >
        <img
          className={classnames(styles.w_100)}
          src={logo}
          alt={t("aic_app_page_title_text")}
        />
      </a>
    </div>
  );
};

export default withTranslation()(PortalLogo);
